import { memo } from 'react';
import { useRouter } from 'next/router';

import { Box } from '@zillow/constellation-10';

import { useGetListingDetails } from '../../../../hooks/queries/properties';

import SpinnerContainer from '../../../SpinnerContainer';
import AdditionalUnitAmenities from './AdditionalUnitAmenities';
import AppliancesAmenities from './AppliancesAmenities';
import CommunicationAmenities from './CommunicationAmenities';
import OtherUnitAmenities from './OtherUnitAmenities';

const UnitFeaturesContent = (): JSX.Element => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { isPending: isListingDetailsPending } = useGetListingDetails(listingAlias);

  if (isListingDetailsPending) {
    return (<SpinnerContainer />) as JSX.Element;
  }

  return (
    <Box
      data-testid="UnitFeaturesContent-Edit"
      css={{ display: 'flex', flexDirection: 'row', gap: '400', flexWrap: 'wrap' }}
    >
      <Box css={{ display: 'flex', flexDirection: 'column', gap: '400', flex: '1 0 280px' }}>
        <AppliancesAmenities />
      </Box>

      <Box css={{ display: 'flex', flexDirection: 'column', gap: '400', flex: '1 0 280px' }}>
        <CommunicationAmenities />

        <OtherUnitAmenities />
      </Box>

      <AdditionalUnitAmenities />
    </Box>
  );
};

export default memo(UnitFeaturesContent);
